import { SearchTab } from "owa-search-types/lib/types/SearchTab";
import { SearchScenarioId } from "owa-search-store";
import { getModuleContextMailboxInfo } from "owa-module-context-mailboxinfo";
import isSharedFolderSearch from "owa-mail-search-utils/lib/utils/isSharedFolderSearch";
import { getSafeSelectedTableView, getViewFilterForTable } from "owa-mail-list-store";
import type { SearchTableQuery } from "owa-mail-list-search";
import { getStore as getMailSearchStore } from "../store/store";
import { getSelectedNode } from "owa-mail-folder-forest-store";
import { type FolderForestNodeType } from "owa-favorites-types";
import type { MailboxInfo } from "owa-client-types";
import { isSearchPlusChatFeatureEnabled } from "owa-search/lib/utils/isSearchPlusChatFeatureEnabled";
import { isAccountFeatureEnabled, isGlobalFeatureEnabled } from "owa-feature-flags";
import { isUnifiedInboxMailboxInfo } from "owa-client-types/lib/UnifiedInboxMailboxInfo";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";

export function isSearchPlusChatFeatureEnabledForSearchSession(scenarioId?: SearchScenarioId, mailboxInfo?: MailboxInfo): boolean {
    const tableView = getSafeSelectedTableView();
    const tableQuery = tableView?.tableQuery;
    const activeSearchTab: SearchTab | undefined = tableQuery
        ? (tableQuery as SearchTableQuery).searchTab
        : undefined;
    let targetMailboxInfo = mailboxInfo || getModuleContextMailboxInfo();
    if (isUnifiedInboxMailboxInfo(targetMailboxInfo)) {
        targetMailboxInfo = getGlobalSettingsAccountMailboxInfo();
    }
    const searchProvider = getMailSearchStore().provider;
    const isInitialPersonaFavoriteFolder = getSelectedNode().type === 1 &&
        getViewFilterForTable(tableView) == null;
    
    // This basic check is for things inherent to the mailbox,
    // while the other checks add in search session context
    const isBasicFeatureEnabled = isSearchPlusChatFeatureEnabled(targetMailboxInfo);
    
    const searchScenarioType = (tableQuery as SearchTableQuery)?.scenarioType;
    const isQueryOnTypeSuggestionsExperimentEnabled = isAccountFeatureEnabled("sea-gwc-query-on-type-with-suggestions", targetMailboxInfo) ||
        isAccountFeatureEnabled("sea-gwc-query-on-type-with-7-results", targetMailboxInfo);
    const isProvisionalSearchTable = searchScenarioType === "messageSuggestion" ||
        (searchScenarioType === "queryOnType" && !isQueryOnTypeSuggestionsExperimentEnabled);
    
    return (isBasicFeatureEnabled &&
        (scenarioId === SearchScenarioId.Mail || scenarioId === undefined) &&
        (activeSearchTab == undefined ||
            activeSearchTab == SearchTab.Mail ||
            activeSearchTab == SearchTab.All) &&
        (isGlobalFeatureEnabled("sea-enableImmersiveSearchForSharedFolders") ||
            !isSharedFolderSearch()) &&
        !isInitialPersonaFavoriteFolder &&
        !isProvisionalSearchTable &&
        (searchProvider === "SubstrateSearchV2" ||
            searchProvider === "UnifiedInbox" ||
            !searchProvider) // Search provider can be undefined in some edge cases, we should still allow SearchPlusChat to show in those cases as long as other conditions are met
    );
}
